<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mx-auto text-center">
      <h5 class="description">
        Escolha um endereço que você deseja utilizar em sua loja
      </h5>
    </div>

    <div class="md-layout-item md-size-70 md-xsmall-size-100 mx-auto">

      <ValidationObserver ref="form">
        <form @submit.prevent="submit()">
          <md-card class="info-card">
            <md-card-header class="md-card-header-icon md-card-header-primary">
              <div class="card-icon">
                <md-icon>local_mall</md-icon>
              </div>
              <h4 class="title">Qual endereço da loja?</h4>
            </md-card-header>

            <md-card-content>
              <ValidationProvider
                name="domain"
                :rules="{
                  required: true, 
                  regex: /^((\w{3,}\:\/\/)?(\w*\.)?[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9])\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,})?$/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field 
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>language</md-icon>
                  <label>Domínio da loja virtual</label>
                  <md-input v-model="storeAddress" autocomplete="domain" type="text" :placeholder="domainExample" @keyup="keyUp"></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>

                </md-field>              
              </ValidationProvider>
            </md-card-content>

            <md-card-actions v-if="needUserAction">
              <md-button v-if="!loader.loading" type="submit" :class="[{'md-success': domain.base && !storeExists}, {'md-info': !domain.base || storeExists}]">
                <span v-if="domain.base && !storeExists">Continuar</span>
                <span v-if="!domain.base || storeExists">Continuar</span>
                </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
    <CollapseContent
      :active="!domain.base || storeExists">
      <template slot="md-collapse-content">
        <div class="md-layout-item md-layout-item md-size-70 md-xsmall-size-100 mx-auto text-center">
          <p class="additional-info"><b>
            Se você ainda não tiver certeza do endereço que você irá utilizar, tudo bem, nós vamos ativar sua loja em um endereço temporário e depois você poderá alterar se precisar.
          </b></p>
        </div>
      </template>
    </CollapseContent>

  </div>
</template>

<script>
import Vue from 'vue'
import { SlideYDownTransition } from "vue2-transitions";
import { extend, validate } from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";
import { CollapseContent } from '@/components'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Domain from '../Domain.js'

extend("required", required);
extend("regex", regex);

export default {
  components: {    
    SlideYDownTransition,
    CollapseContent        
  },

  data() {
    return {
      loader: this.$store.state.loader,
      info:   this.$store.state.info,

      domain: this.$store.state.domain,
      client: this.$store.state.client,

      storeAddress: "",
      storeExists: false,

      domainAlert:{ msg: '', type: 'info' },
      needUserAction: true,

      alerts: {
        storeExists: {
          msg: 'Já existe uma loja virtual ativa com este endereço na iSET. Informe outro domínio para continuar.',
          type: 'danger'
        },              
        storeYoursActive: {
          msg: 'Você já possui uma loja virtual ativa com este endereço. Caso queira outra loja no mesmo domínio, informe um subdomínio.',
          type: 'danger'
        },              
        storeYoursInactive: {
          msg: 'Você já possui uma loja virtual inativa com este endereço. Entre em contato com nosso time comercial para reativar sua loja.',
          type: 'danger'
        },              
        domainExists: {
          msg: 'Você pode continuar, mas o endereço que você escolheu parece já estar registrado. Continue mesmo assim ou troque o endereço para tentar outra vez.',
          type: 'warning'
        },              
        domainAvailable: {
          msg: 'Parabéns! O endereço que você escolheu está disponível para registro!',
          type: 'success'
        },              
      }
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      this.$gtm.trackEvent({
        event: 'Escolha do Domínio',
        category: "domain",
        action: "view",
        transaction_id: this.$store.state.session.id,
        noninteraction: false,
      });
      
      this.$store.commit('domain', ['protocol', 'https']);
    })
  },

  computed:{
    domainExample() { 
      return "ex: www." + this.$store.state.tempDomain;
    },
  },

  methods: {
    keyUp: function(e) {
      if (e && e.keyCode === 13) {        
        this.submit();
      } else {
        this.$debug('Domain => storeAddressChanged');        
        this.$store.commit('domain', ['subdomain', '']);
        this.$store.commit('domain', ['base', '']);
        this.$store.commit('domain', ['extension', '']);
        this.$store.commit('domain', ['status', '']);
        this.$functions.closeInfo();
      }
    },

    validate() {
      return this.$refs.form.validate().then(res => {        
        return res;
      });
    },

    submit(){  
      this.$debug('Domain => submit');

      this.validate().then(res => {
        if (res){
          if (!this.domain.base || this.storeExists)
            this.checkDomain();
          else this.next();
        }
      })
    },

    checkDomain(){
      this.$debug('Domain => checkDomain');
      this.needUserAction = true;
      this.$store.commit('loader', [true, "Aguarde", "Verificando domínio..."]);
      const domain = new Domain(this.storeAddress);
      const parts  = domain.parts();

      if(!parts.base || !parts.extension) return;
      
      const params = {'subdomain': parts.subdomain,
                      'domain': parts.base+'.'+parts.extension};

      this.$functions.get('checkDomain', params, 'plan.php').then((response) => {        
        if (response.result == "success" && 
            response.subdomain == parts.subdomain &&
            response.domain == parts.base+'.'+parts.extension){
          const available = response.whois.status == 'available';
          const hosting   = response.ica.hosting;
          const ecommerce = response.ica.ecommerce;
          this.$debug('Domain Available: ' + available);
          this.$debug(hosting);
          this.$debug(ecommerce);

          this.$store.commit('hosting', ['id', hosting.id]);          

          if (ecommerce.id && (ecommerce.status == 'active' || ecommerce.status == 'suspended' || ecommerce.userid == this.client.id)){
            if (ecommerce.userid == this.client.id){
              //Loja criada com mesmo cliente logado na ativação
              if (ecommerce.status == 'active')
                this.$functions.showInfo(this.alerts.storeYoursActive.msg, this.alerts.storeYoursActive.type);
              else
                this.$functions.showInfo(this.alerts.storeYoursInactive.msg, this.alerts.storeYoursInactive.type);              
            } else {
              //Loja ativa criada por outro cliente
              this.$functions.showInfo(this.alerts.storeExists.msg, this.alerts.storeExists.type);
            }
            this.storeExists = true;
            this.$store.commit('ecommerce', ['id', ecommerce.id]);
          }
          else{
            this.storeExists = false;
            if (available){
              this.needUserAction = false;
              this.$functions.showInfo(this.alerts.domainAvailable.msg, this.alerts.domainAvailable.type);
              setTimeout(() => this.next(), 1000);
            }
            else
              this.$functions.showInfo(this.alerts.domainExists.msg, this.alerts.domainExists.type);              
          }

          this.$store.commit('domain', ['subdomain', parts.subdomain ? parts.subdomain : 'www']);
          this.$store.commit('domain', ['base', parts.base]);
          this.$store.commit('domain', ['extension', parts.extension]);
          this.$store.commit('domain', ['status', response.whois.status]);
        }        

        this.$store.commit('loader', [false]);
      });      

    },

    next(){
      this.$debug('Domain => next');

      const params = {'id'              : this.$store.state.session.id,
                      'email'           : this.$store.state.client.email,
                      'subdomain'       : this.$store.state.domain.subdomain,
                      'domainbase'      : this.$store.state.domain.base,
                      'domainextension' : this.$store.state.domain.extension,
                      'domainstatus'    : this.$store.state.domain.status,
                      'counter_domain'  : 1 };
      this.$functions.addTrack(params);

      this.$functions.closeInfo();      
      this.$router.push({ path: 'plano' });
    }
  },
};
</script>

<style lang="scss">
@import "../assets/scss/activation.scss";
.info-card .md-card-content{
  margin-top: 20px;
}

.additional-info{
  font-size: 14px;
  line-height: 20px;
  color: #555;
}

@media only screen and (max-width: 600px) {
  .title{
    font-size: 20px;
  }
}

</style>